export default "__VITE_ASSET__B1d3j_JN__"